export function options(url, params = {}) {
  const options = { ...params };
  const urlParams = Object.keys(options)
    .map(k => encodeURIComponent(k) + "=" + encodeURIComponent(options[k]))
    .join("&");
  return (url += (url.indexOf("?") === -1 ? "?" : "&") + urlParams);
}
